import {Person, DownloadingOutlined, MenuOutlined} from "@mui/icons-material";
import {Box, IconButton} from "@mui/material";
import {t} from "i18next";
import {Tooltip} from "react-bootstrap";
import LanguageChanger from "../../../components/LanguageChanger";
import ThemeSwitch from "./ThemeSwitch";
import useMediaQuery from "@mui/material/useMediaQuery";


export default function DrawersController({setOpenDrawer, setOpenUserDrawer, setOpenMenu, openUserDrawer, openMenu, openDrawer}) {
    const matchMobile =  useMediaQuery('(max-width: 600px)');

    return (
        <>
            <Box sx={{
                display: "flex",
                minHeight: "64px",
                justifyContent: "space-between",
                alignItems: "center",
                width: '100%',
                minWidth: matchMobile ? '100vw' : '250px',
                px: matchMobile ? 1 : 0,
                pr: 2
            }}>
                <Tooltip title={t('users-panel.title')}><IconButton onClick={() => {setOpenUserDrawer(!openUserDrawer); setOpenDrawer(false); setOpenMenu(false);}} sx={{cursor: 'pointer'}}><Person /></IconButton></Tooltip>
                <Tooltip title={t('common:actions-panel.title')}><IconButton onClick={() => {setOpenUserDrawer(false); setOpenDrawer(!openDrawer); setOpenMenu(false);}} sx={{cursor: 'pointer'}}><DownloadingOutlined /></IconButton></Tooltip>
                <LanguageChanger />
                <ThemeSwitch />

                {matchMobile && <IconButton
                    onClick={() => {setOpenUserDrawer(false); setOpenDrawer(false); setOpenMenu(!openMenu);}}
                >
                    <MenuOutlined />
                </IconButton>}
            </Box>
        </>
    );
}